export const getResources = (language: string): { [id: string]: string } => {
    if (language === 'en-US') {
        return {
            deleteButtonText: 'Delete',
            validationSummaryHeader: 'Check that the following are filled in correctly:',
            validationFileMax: 'File size must be less than 25MB',
            validationFileType: 'The file type must be jpeg, png, or pdf',
            supportedFileFormats: 'Valid file formats are jpeg, png and pdf',
            selectDefaultPlaceholder: 'Select one of the options.',
            resetTime: 'Reset time',
            errorAfterMaxDate: 'Date cannot be after maximum date',
            errorBeforeMinDate: 'Date cannot be before minimum date',
            dateRequired: 'Select date, or enter date as follows: dd.mm.yyyy.',
            oppgiTid: ' Enter time',
            ugyldigTid: 'Invalid time',
            ugyldigDatoTid: 'Invalid date and time',
            oppgiVerdi: 'Select one of the options.',
            oppgiGyldigVerdi: 'Please enter a valid value',
            formCancel: 'Cancel',
            formSend: 'Submit',
            formSave: 'Show QuestionnaireResponse',
            formError: 'Check that everything is filled in correctly.',
            formOptional: '(optional)',
            formRequired: '(required)',
            repeatButtonText: 'Add',
            avsluttSkjema: 'Discard changes',
            fortsett: 'Continue editing',
            confirmDeleteButtonText: 'Delete row',
            confirmDeleteCancelButtonText: 'Discard changes',
            confirmDeleteHeading: 'There are unsaved changes',
            confirmDeleteDescription: 'If you delete the row, your changes will be discarded.',
            minutePlaceholder: 'mm',
            hourPlaceholder: 'hh',
            ikkeBesvart: 'Not answered',
            uploadButtonText: 'Upload file',
            filterDateCalendarButton: 'Select date',
            filterDateNavigateBackward: 'Back',
            filterDateNavigateForward: 'Forward',
            filterDateErrorDateFormat: 'The date is entered in the wrong format',
            filterDateErrorBeforeMinDate: 'From date can not be earlier than before date',
            filterDateErrorAfterMaxDate: 'From date can not be later than to date',
            validationNotAllowed: 'is not allowed',
            formRequiredErrorMessage: 'This field is required',
            deleteAttachmentText: 'Delete',
            autoSuggestLoadError: 'Technical error',
            autosuggestNoSuggestions: 'No results found for "{0}". Try another word or check for spelling errors.',
            stringOverMaxLengthError: 'You have typed too many characters. Make the text shorter.',
            maxLengthText: 'Maximum {0} characters',
            chooseFilesText: 'Select files',
            skipLinkText: 'Go to navigator',
            clearDate: 'Remove date',
            calendarLabel: 'Calendar',
            closeDatePicker: 'Close',
            focusStartDate: 'Use the calendar and select a date',
            jumpToPrevMonth: 'Go backward to last month',
            jumpToNextMonth: 'Go forward to next month',
            keyboardShortcuts: 'Keyboard shortcuts',
            showKeyboardShortcutsPanel: 'Open the keyboard shortcuts panel',
            hideKeyboardShortcutsPanel: 'Close the keyboard shortcut panel',
            enterKey: 'Enter key',
            leftArrowRightArrow: 'Right and left arrow keys',
            upArrowDownArrow: 'Up and down arrow keys',
            pageUpPageDown: 'Page up and Page down key',
            homeEnd: 'Home and End key',
            escape: 'Escape key',
            questionMark: 'Question mark',
            openThisPanel: 'Open this panel',
            selectFocusedDate: 'Select the date that has focus',
            moveFocusByOneDay: 'Move one day backward (left) and forward (right)',
            moveFocusByOneWeek: 'Move one week backward (up) and forward (down)',
            moveFocusByOneMonth: 'Change month',
            moveFocustoStartAndEndOfWeek: 'Go to the first or last day of the week',
            returnFocusToInput: 'Return to the date in the input field',
            year_field_invalid: 'Enter a valid value for the year field',
            year_field_maxdate: 'The latest year you can choose is',
            year_field_mindate: 'The earliest year you can choose is',
            year_field_required: 'Year is required',
            yearmonth_field_invalid: 'Invalid value',
            yearmonth_field_invalid_year: 'You must enter a valid year',
            yearmonth_field_maxdate: 'The latest time you can choose is',
            yearmonth_field_mindate: 'The earliest time you can choose is',
            yearmonth_field_month_placeholder: 'Choose month',
            yearmonth_field_required: 'Year and month is required',
            yearmonth_field_year_placeholder: 'Choose year',
            adresseKomponent_header: 'Who is the recipient?',
            adresseKomponent_skjemaSendesTil: 'Questionnaire will be sent to:',
            adresseKomponent_sublabel: 'You must select recipient before submitting the questionnaire.',
            adresseKomponent_velgAvdeling: 'Select department',
            adresseKomponent_velgHelseforetak: 'Select health company',
            adresseKomponent_velgHelseregion: 'Select health region',
            adresseKomponent_velgSykehus: 'Select hospital',
            adresseKomponent_velgKlinikk: 'Select clinic',
            adresseKomponent_velgSeksjon: 'Select section',
            adresseKomponent_velgSengepost: 'Select bed post',
            adresseKomponent_velgPoliklinikk: 'Select polyclinic',
            adresseKomponent_velgTjeneste: 'Select place of treatment',
            adresseKomponent_feilmelding: 'You must select a recipient.',
            adresseKomponent_loadError: 'Technical error. Could not load recipients.',
            linkOpensInNewTab: 'Opens in new tab',
            nextStep: 'Next',
            previousStep: 'Previous',
            openChoiceOption: 'Other',
        };
    }
    return {
        deleteButtonText: 'Löschen',
        validationSummaryHeader: 'Bitte überprüfen Sie, ob die folgenden Felder korrekt ausgefüllt sind:',
        validationFileMax: 'Die Dateigröße muss kleiner als 25 MB sein',
        validationFileType: 'Der Dateityp muss jpeg, png oder pdf sein',
        supportedFileFormats: 'Gültige Dateiformate sind jpeg, png und pdf',
        selectDefaultPlaceholder: 'Wählen Sie eine der Optionen.',
        resetTime: 'Zeit zurücksetzen',
        errorAfterMaxDate: 'Das Datum darf nicht nach dem Maximaldatum liegen',
        errorBeforeMinDate: 'Das Datum darf nicht vor dem Minimaldatum liegen',
        dateRequired: 'Wählen Sie ein Datum oder geben Sie es wie folgt ein: tt.mm.jjjj.',
        oppgiTid: 'Zeit eingeben',
        ugyldigTid: 'Ungültige Uhrzeit',
        ugyldigDatoTid: 'Ungültiges Datum und Uhrzeit',
        oppgiVerdi: 'Wählen Sie eine der Optionen.',
        oppgiGyldigVerdi: 'Bitte geben Sie einen gültigen Wert ein',
        formCancel: 'Abbrechen',
        formSend: 'Absenden',
        formSave: 'Fragebogenantwort anzeigen',
        formError: 'Überprüfen Sie, ob alles korrekt ausgefüllt ist.',
        formOptional: '(optional)',
        formRequired: '(erforderlich)',
        repeatButtonText: 'Hinzufügen',
        avsluttSkjema: 'Änderungen verwerfen',
        fortsett: 'Bearbeitung fortsetzen',
        confirmDeleteButtonText: 'Zeile löschen',
        confirmDeleteCancelButtonText: 'Änderungen verwerfen',
        confirmDeleteHeading: 'Es gibt ungespeicherte Änderungen',
        confirmDeleteDescription: 'Wenn Sie die Zeile löschen, werden Ihre Änderungen verworfen.',
        minutePlaceholder: 'mm',
        hourPlaceholder: 'hh',
        ikkeBesvart: 'Nicht beantwortet',
        uploadButtonText: 'Datei hochladen',
        filterDateCalendarButton: 'Datum auswählen',
        filterDateNavigateBackward: 'Zurück',
        filterDateNavigateForward: 'Weiter',
        filterDateErrorDateFormat: 'Das Datum wurde im falschen Format eingegeben',
        filterDateErrorBeforeMinDate: 'Das "Von"-Datum darf nicht vor dem "Vor"-Datum liegen',
        filterDateErrorAfterMaxDate: 'Das "Von"-Datum darf nicht nach dem "Bis"-Datum liegen',
        validationNotAllowed: 'ist nicht erlaubt',
        formRequiredErrorMessage: 'Dieses Feld ist erforderlich',
        deleteAttachmentText: 'Löschen',
        autoSuggestLoadError: 'Technischer Fehler',
        autosuggestNoSuggestions:
            'Keine Ergebnisse für "{0}" gefunden. Versuchen Sie ein anderes Wort oder überprüfen Sie die Schreibweise.',
        stringOverMaxLengthError: 'Sie haben zu viele Zeichen eingegeben. Bitte kürzen Sie den Text.',
        maxLengthText: 'Maximal {0} Zeichen',
        chooseFilesText: 'Dateien auswählen',
        skipLinkText: 'Zum Navigator wechseln',
        clearDate: 'Datum entfernen',
        calendarLabel: 'Kalender',
        closeDatePicker: 'Schließen',
        focusStartDate: 'Verwenden Sie den Kalender und wählen Sie ein Datum',
        jumpToPrevMonth: 'Zum letzten Monat zurückgehen',
        jumpToNextMonth: 'Zum nächsten Monat weitergehen',
        keyboardShortcuts: 'Tastenkombinationen',
        showKeyboardShortcutsPanel: 'Bereich für Tastenkombinationen öffnen',
        hideKeyboardShortcutsPanel: 'Bereich für Tastenkombinationen schließen',
        enterKey: 'Eingabetaste',
        leftArrowRightArrow: 'Rechte und linke Pfeiltaste',
        upArrowDownArrow: 'Obere und untere Pfeiltaste',
        pageUpPageDown: 'Bild-auf- und Bild-ab-Taste',
        homeEnd: 'Pos1- und Ende-Taste',
        escape: 'Escape-Taste',
        questionMark: 'Fragezeichen',
        openThisPanel: 'Diesen Bereich öffnen',
        selectFocusedDate: 'Fokussiertes Datum auswählen',
        moveFocusByOneDay: 'Einen Tag zurück (links) und vor (rechts) bewegen',
        moveFocusByOneWeek: 'Eine Woche zurück (hoch) und vor (runter) bewegen',
        moveFocusByOneMonth: 'Monat ändern',
        moveFocustoStartAndEndOfWeek: 'Zum ersten oder letzten Tag der Woche gehen',
        returnFocusToInput: 'Zum Datum im Eingabefeld zurückkehren',
        year_field_invalid: 'Geben Sie einen gültigen Wert für das Jahresfeld ein',
        year_field_maxdate: 'Das späteste Jahr, das Sie wählen können, ist',
        year_field_mindate: 'Das früheste Jahr, das Sie wählen können, ist',
        year_field_required: 'Jahr ist erforderlich',
        yearmonth_field_invalid: 'Ungültiger Wert',
        yearmonth_field_invalid_year: 'Sie müssen ein gültiges Jahr eingeben',
        yearmonth_field_maxdate: 'Der späteste Zeitpunkt, den Sie wählen können, ist',
        yearmonth_field_mindate: 'Der früheste Zeitpunkt, den Sie wählen können, ist',
        yearmonth_field_month_placeholder: 'Monat wählen',
        yearmonth_field_required: 'Jahr und Monat sind erforderlich',
        yearmonth_field_year_placeholder: 'Jahr wählen',
        adresseKomponent_header: 'Wer ist der Empfänger?',
        adresseKomponent_skjemaSendesTil: 'Fragebogen wird gesendet an:',
        adresseKomponent_sublabel: 'Sie müssen einen Empfänger auswählen, bevor Sie den Fragebogen absenden.',
        adresseKomponent_velgAvdeling: 'Abteilung wählen',
        adresseKomponent_velgHelseforetak: 'Gesundheitsunternehmen wählen',
        adresseKomponent_velgHelseregion: 'Gesundheitsregion wählen',
        adresseKomponent_velgSykehus: 'Krankenhaus wählen',
        adresseKomponent_velgKlinikk: 'Klinik wählen',
        adresseKomponent_velgSeksjon: 'Sektion wählen',
        adresseKomponent_velgSengepost: 'Station wählen',
        adresseKomponent_velgPoliklinikk: 'Poliklinik wählen',
        adresseKomponent_velgTjeneste: 'Behandlungsort wählen',
        adresseKomponent_feilmelding: 'Sie müssen einen Empfänger auswählen.',
        adresseKomponent_loadError: 'Technischer Fehler. Empfänger konnten nicht geladen werden.',
        linkOpensInNewTab: 'Öffnet in neuem Tab',
        nextStep: 'Weiter',
        previousStep: 'Zurück',
        openChoiceOption: 'Sonstiges',
    };
};
